export default __webpack_public_path__ + "static/media/x.33076876.svg";